<template>
  <v-card style="margin-bottom: 24px">
    <CreateGroupForm :state="dialog" :subjects="subjects" @closeDialog="close" @refresh="refresh" />
    <UdpateGroupForm
      :state="updateDialog"
      :subjects="subjects"
      :data="item"
      @closeDialog="closeUpdate"
      @refresh="refresh"
    />
    <PriorityOrderDialog
      :state="priorityDialog"
      :subjects="subjects"
      :subjectGroups="subjectGroups"
      @closeDialog="closePriority"
      @refresh="refresh"
    />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Danh sách tổ hợp môn</h5>
    </div>
    <div class="d-flex justify-between align-center pr-6">
      <v-btn color="primary" outlined class="elevation-0 ml-6" @click="openPriority">
        <v-icon left>mdi-format-list-numbered</v-icon>Chỉnh thứ tự ưu tiên</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn color="primary" class="elevation-0" dark @click="openCreate">
        <v-icon left>mdi-plus</v-icon>Thêm tổ hợp môn</v-btn
      >
    </div>
    <div class="pa-6">
      <v-card>
        <v-data-table
          item-key="id"
          :headers="computedHeaders"
          :loading="loading"
          :items="subjectGroups"
          :items-per-page="10"
          :disable-sort="$vuetify.breakpoint.smAndDown"
          :footer-props="{ 'items-per-page-text': 'Số nhóm mỗi trang' }"
          v-bind="this.$attrs"
        >
          <template v-slot:[`footer.page-text`]="items">
            Môn thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} môn
          </template>
          <template v-slot:[`item.type`]="{ item }">
            {{ item | getType }}
          </template>
          <template v-for="subject in subjects" v-slot:[`item.subject_${subject.id}`]="{ item }">
            <div :key="subject.id">
              <v-checkbox :input-value="hasSubject(item, subject.id)" disabled></v-checkbox>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" @click="update(item)" v-bind="attrs" v-on="on" icon>
                    <v-icon> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Chỉnh sửa tổ hợp thi</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import CreateGroupForm from './CreateGroupForm.vue'
import PriorityOrderDialog from './PriorityOrderDialog.vue'
import UdpateGroupForm from './UdpateGroupForm.vue'
const originHeaders = [
  {
    text: 'STT ưu tiên',
    value: 'index',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  },
  {
    text: 'Tên tổ hợp',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  },
  {
    text: 'Loại tổ hợp',
    value: 'type',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },

  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  }
]

export default {
  props: {
    subjectGroups: Array,
    subjects: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      subjectHeaders: [],
      dialog: false,
      updateDialog: false,
      priorityDialog: false,
      item: {
        type: '',
        subjects: []
      }
    }
  },
  computed: {
    computedHeaders() {
      const action = this.headers.findIndex(header => header.value === 'actions')
      const before = this.headers.slice(0, action)
      const after = this.headers.slice(action)
      return [...before, ...this.subjectHeaders, ...after]
    }
  },
  methods: {
    update(item) {
      this.item = item
      this.updateDialog = true
    },
    openCreate() {
      this.dialog = true
    },
    openPriority() {
      this.priorityDialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.updateDialog = false
    },
    closePriority() {
      this.priorityDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    hasSubject(room, subjectId) {
      return room.subjects.some(subject => subject.id === subjectId)
    }
  },
  watch: {
    subjectGroups(newVal) {
      if (newVal) {
        this.loading = false
      }
    },
    subjects(newSubjects) {
      this.subjectHeaders = newSubjects.map(subject => ({
        text: subject.name,
        value: `subject_${subject.id}`,
        align: 'left',
        sortable: false,
        width: '10%'
      }))
    }
  },
  filters: {
    getType: item => {
      if (item.type === 'default') {
        return 'Mặc định'
      } else if (item.type === 'basic') {
        return 'Cơ bản'
      } else if (item.type === 'advanced') {
        return 'Tiên tiến'
      } else {
        return '-'
      }
    }
  },
  components: { CreateGroupForm, UdpateGroupForm, PriorityOrderDialog }
}
</script>
